__turbopack_context__.v({
  "calculator": "hzzo_q_calculator",
  "controls": "hzzo_q_controls",
  "cta": "hzzo_q_cta",
  "header": "hzzo_q_header",
  "included": "hzzo_q_included",
  "includedList": "hzzo_q_includedList",
  "includedTitle": "hzzo_q_includedTitle",
  "intro": "hzzo_q_intro",
  "metaCard": "hzzo_q_metaCard",
  "metaFigure": "hzzo_q_metaFigure",
  "metaFootnote": "hzzo_q_metaFootnote",
  "metaHeader": "hzzo_q_metaHeader",
  "metaLabel": "hzzo_q_metaLabel",
  "metaLine": "hzzo_q_metaLine",
  "metaRow": "hzzo_q_metaRow",
  "metaValue": "hzzo_q_metaValue",
  "optionAmount": "hzzo_q_optionAmount",
  "optionContent": "hzzo_q_optionContent",
  "optionGroup": "hzzo_q_optionGroup",
  "optionUnit": "hzzo_q_optionUnit",
  "partnershipBadge": "hzzo_q_partnershipBadge",
  "perfectFor": "hzzo_q_perfectFor",
  "perfectForList": "hzzo_q_perfectForList",
  "perfectForTitle": "hzzo_q_perfectForTitle",
  "priceCard": "hzzo_q_priceCard",
  "priceCardDiscounted": "hzzo_q_priceCardDiscounted",
  "priceHint": "hzzo_q_priceHint",
  "priceLabel": "hzzo_q_priceLabel",
  "priceTerms": "hzzo_q_priceTerms",
  "priceValue": "hzzo_q_priceValue",
  "rateSuperseded": "hzzo_q_rateSuperseded",
  "summaryFooter": "hzzo_q_summaryFooter",
  "totalCard": "hzzo_q_totalCard",
  "totalLabel": "hzzo_q_totalLabel",
  "totalNote": "hzzo_q_totalNote",
  "totalValue": "hzzo_q_totalValue",
  "unitSwitch": "hzzo_q_unitSwitch",
  "workload": "hzzo_q_workload",
});
